export default __webpack_public_path__ + "static/media/remove-circle-disabled.1cce3013.svg";